import { isLocal } from '@lcsc-ui/utils/baseUrl';
import { doGet, doPost } from '@lcsc-ui/utils/request';

let APIHost = '/lcsc-so';
const domain = 'lcscSearchUrl';
if (isLocal) {
  APIHost = 'https://devso.szlcsc.com';
}

// node请求接口
export default {
  checkQuery: `${APIHost}/check/query`,
  resourceList: `${APIHost}/resource/list`,
  catalogList: `${APIHost}/resource/catalog/list`,
  global: `${APIHost}/${isLocal ? 'global' : 'query'}`,
  mroGlobal: `${APIHost}/mroso/global`,
  bomList: `${APIHost}/bom`,
};

export function getStockpilleHistory() {
  return doGet(domain, '/www/stockpile/history?source=so');
}

// 获取对比商品
export function getCompareProduct() {
  return doGet(domain, '/compare/product/get/V2');
}
// 添加对比商品
export function addCompareProduct(query) {
  return doGet(domain, '/compare/product/add/V2', query);
}
// 移除对比商品
export function removeCompareProduct(query) {
  return doGet(domain, '/compare/product/remove/V2', query);
}
// 移除全部对比商品
export function removeAllCompareProduct() {
  return doGet(domain, '/compare/product/removeAll/V2');
}
// 进行对比商品
export function checkCompareProduct() {
  return doGet(domain, '/compare/product/check/V2');
}
// 校验立推购买
export function groupValidatePerfect(query) {
  return doGet(domain, '/async/group/validate/perfect', query);
}
// 校验秒杀购买
export function secondKillValidatePerfect(query) {
  return doGet(domain, '/async/second/kill/validate/perfect', query);
}
// 热门找料弹窗保存
export function asyncEnquirySave(body) {
  return doPost(domain, `/async/enquiry/save`, body);
}
// 展示数据手册
export function showProductPDFAndPCB(query) {
  return doGet(domain, `/product/showProductPDFAndPCB`, query);
}

// 客户端二次查询
export function secondQueryGlobal(body) {
  return doPost(domain, '/query/product', body);
}

// mro客户端二次查询
export function secondQueryMroGlobal(body) {
  return doPost(domain, '/mroso/query/product', body);
}

//判断是否弹出个性标签弹窗
export function asyncMemberLabelShow(query) {
  return doGet(domain, '/async/member/label/show', query);
}

// 获取个性标签列表
export function asyncMemberLabelList(query) {
  return doGet(domain, '/async/member/label/list', query);
}

// 上报已经弹窗过 后续不再弹窗
export function asyncMemberLabelConfirm(body) {
  return doPost(domain, '/async/member/label/confirm', body);
}

// 保存自定义标签
export function asyncMemberLabelCustomizeSave(body) {
  return doPost(domain, '/async/member/label/customize/save', body);
}

// 保存选中标签
export function asyncMemberLabelEdit(body) {
  return doPost(domain, '/async/member/label/edit', body);
}

// 大转盘抽检
export function lotteryActivityPopup(query) {
  return doGet(domain, '/lottery/activity/popup/index', query);
}

// 异步查询商品参数
export function queryParamAgg(body, sign) {
  return doPost(domain, `/query/param/agg?sign=${sign}`, body);
}
